import React from 'react'
import { NewAppLayout } from '@/components/new-ux/layout/NewAppLayout'
import { CampaignPerformanceTest } from "@/components/client-reporting/CampaignPerformanceTest"


export default function CampaignPerformanceTestPage() {
  return (
    <NewAppLayout fullWidth>
      <CampaignPerformanceTest />
    </NewAppLayout>
  )
}
